import { createSelector } from "reselect";
import _ from "lodash";

const linkedList = state => state.shop.linked


export const isInventoryHq = createSelector(
    [linkedList],
    (linkedList) => {
        if (linkedList.inventory !== null) {
            return false
        }
        return true
    })